import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class AreaPage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { areaPage,currentArea} = this.props.system;
     this.fetchList( areaPage);
  }

  fetchList = (page,values) => {
    const {getAreaList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getAreaList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { areaById, areaList } = system;
    if (!areaList) return [];
    return areaList.map(id => areaById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getAreaListPending,areaTotal,areaPage } = system
    const { deleteArea,chooseCurrentArea,areaModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getAreaListPending,
      columns:[
        {
          title: "名称",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:areaTotal,
        current:areaPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentArea(record);
          areaModalChange(true,"updata");
        }else if(item.key == 3){
            deleteArea(record.id).then((data) => {
            this.fetchList(areaPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentArea, areaModalVisible,areaPage, areaModalType,submitAreaPending } = system

    const { areaModalChange,submitArea } = actions;
    const editItem  = areaModalType === 'create' ? {} : currentArea
    return {
      item: areaModalType === 'create' ? {} : currentArea,
      visible: areaModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitAreaPending,
      title: `${
        areaModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "name",
          label: "名称",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitArea(Object.assign({},data,{})).then(data=> {
          areaModalChange(false,"create");
          this.fetchList(areaPage);
        })
      },
      onCancel() {
        areaModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentArea,areaPage} = system
    const { areaModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入名称"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        areaModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentArea,areaPage} = system
    const { areaModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ areaModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AreaPage);


// WEBPACK FOOTER //
// ./src/features/system/AreaPage.js